export enum EnumLikeableEntityType {
    Comment = "Comment",
    Magazine = "Magazine",
    ExternalNewsArticle = "ExternalNewsArticle",
    Wikifolio52WeekHigh = "Wikifolio52WeekHigh",
    WikifolioTagAssignment = "WikifolioTagAssignment",
    WikifolioPortfolioChange = "WikifolioPortfolioChange",
    WikifolioTakingProfits = "WikifolioTakingProfits",
    UnderlyingTradingSentimentBuy = "UnderlyingTradingSentimentBuy",
    UnderlyingTradingSentimentSell = "UnderlyingTradingSentimentSell",
    UnderlyingListFearOfMissingOut = "UnderlyingListFearOfMissingOut",
    UnderlyingListBuyingTheDip = "UnderlyingListBuyingTheDip",
    UnderlyingListTakingProfits = "UnderlyingListTakingProfits",
    UnderlyingListJumpingShip = "UnderlyingListJumpingShip",
    Recommendation = "recommendation",
    BuySellSentiment = "buySellSentiment",
}
